<template>
    <div class="d-block" :style="{height: $common.content.height - 102 + 'px'}">
        <div class="d-flex">
            <a @click="onAddUser">
                <img src="static/img/home-add-user.png" style="height: 104px;"/>
            </a>
            <a @click="onAddTask" v-if="false">
                <img src="static/img/home-add-task.png" style="height: 104px;"/>
            </a>
            <div class="d-flex-item ml-md">
                <Card :bordered="false">
                    <Row :gutter="24">
                        <Col span="6">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-user.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 v-if="userCount" style="color: #00cc99;">{{ userCount.totalUserCount }} 人</h2>
                                    <p>总计用户</p>
                                </div>
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-doc.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 v-if="userCount" style="color: #00cc99;">{{ userCount.todayUserCount }} 人</h2>
                                    <p>今日建档</p>
                                </div>
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-all-exam.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 v-if="userCount" style="color: #00cc99;">{{ userCount.totalAssessCount }} 次</h2>
                                    <p>总计测评</p>
                                </div>
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-day-exam.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 v-if="userCount" style="color: #00cc99;">{{ userCount.todayAssessCount }} 次</h2>
                                    <p>今日测评</p>
                                </div>
                            </div>
                        </Col>
                        <!-- <Col span="4">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-all-test.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 style="color: #00cc99;">{{ userCount.totalExerciseCount }} 次</h2>
                                    <p>总计练习</p>
                                </div>
                            </div>
                        </Col> -->
                        <!-- <Col span="4">
                            <div class="d-flex justify-start ptb-xs">
                                <img src="static/img/home-day-test.png"/>
                                <div class="d-flex-item pl-xs">
                                    <h2 style="color: #00cc99;">{{ userCount.todayExerciseCount }} 次</h2>
                                    <p>今日练习</p>
                                </div>
                            </div>
                        </Col> -->
                    </Row>
                </Card>
            </div>
        </div>
        <br/>
        <div class="d-flex">
            <div class="d-flex-item">
                <Card :bordered="false">
                    <div id="ageCharts" class="d-block" style="height: 320px;"/>
                </Card>
            </div>
            <div class="d-flex-item plr-md">
                <Card :bordered="false">
                    <div id="useCharts" class="d-block" style="height: 320px;"/>
                </Card>
            </div>
            <div class="d-block">
                <Card :bordered="false" v-if="userCount">
                    <i-circle :size="133" :trail-width="4" :stroke-width="5" :percent="userCount.totalManCount > 0 ? ((100 / userCount.totalUserCount) * userCount.totalManCount) : 0" stroke-linecap="square" stroke-color="#43a3fb">
                        <div class="d-block align-center">
                            <h2>{{ userCount.totalManCount > 0 ? ((100 / userCount.totalUserCount) * userCount.totalManCount).toFixed(0) : 0 }}%</h2>
                            <p>男性用户</p>
                        </div>
                    </i-circle>
                </Card>
                <br/>
                <Card :bordered="false" v-if="userCount">
                    <i-circle :size="133" :trail-width="4" :stroke-width="5" :percent="userCount.totalWomanCount > 0 ? ((100 / userCount.totalUserCount) * userCount.totalWomanCount) : 0" stroke-linecap="square" stroke-color="#ff9900">
                        <div class="d-block align-center">
                            <h2>{{ userCount.totalWomanCount > 0 ? ((100 / userCount.totalUserCount) * userCount.totalWomanCount).toFixed(0) : 0 }}%</h2>
                            <p>女性用户</p>
                        </div>
                    </i-circle>
                </Card>
            </div>
        </div>
        <br/>
        <div class="d-block">
            <Card :bordered="false">
                <p slot="title">测评列表</p>
                <Table :columns="tableColumns" :data="tableData">
                    <template slot-scope="{ row, index }" slot="beginTime">
                        <span>{{ row.beginTime ? $moment(row.beginTime).format('YYYY-MM-DD') : '' }}</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="endTime">
                        <span>{{ row.endTime ? $moment(row.endTime).format('YYYY-MM-DD') : '' }}</span>
                    </template>
                    <template slot-scope="{ row, index }" slot="progress">
                        <Progress :percent="row.progress"/>
                    </template>
                    <template slot-scope="{ row, index }" slot="status">
                        <Button type="primary" icon="md-stopwatch" size="small" v-if="new Date().getTime() <= row.endTime && row.progress < 100">执行中</Button>
                        <Button type="success" icon="md-checkmark-circle" size="small" v-if="row.progress === 100">已完成</Button>
                        <Button type="error" icon="md-power" size="small" v-if="new Date().getTime() > row.endTime && row.progress < 100">已结束</Button>
                    </template>
                    <template slot-scope="{ row, index }" slot="action" v-if="new Date().getTime() < row.endTime && row.progress < 100">
                        <button class="btn btn-sm btn-icons btn-success" @click="onChange(row, index, 0)">
                            <img src="static/icon/details-white@16px.png"/>
                        </button>
                    </template>
                </Table>
            </Card>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        components: {},
        data() {
            return {
                userCount: null,
                ageCharts: null, // 年龄统计
                useCharts: null, // 测训统计

                tableColumns: [
                    {
                        title: '任务名称',
                        key: 'taskName',
                        width: 300,
                    },
                    {
                        title: '用户数',
                        key: 'testCount',
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: '开始时间',
                        slot: 'beginTime',
                        align: 'center',
                    },
                    {
                        title: '结束时间',
                        slot: 'endTime',
                        align: 'center',
                    },
                    {
                        title: '完成进度',
                        slot: 'progress',
                        width: 240,
                        align: 'center',
                    },
                    {
                        title: '状态',
                        slot: 'status',
                        align: 'center',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 76,
                    }
                ],
                tableData: [],
            }
        },
        async beforeDestroy() {},
        async created() {},
        async mounted() {
            await this.getUserCount();
            await this.__ageCharts();
            await this.__useCharts();
            await this.getTask(1);
        },
        methods: {
            async onAddUser(){
                return await this.$bus.emit('initChangeUser', true, {}, 1);
            },
            async onAddTask(){
                // this.$bus.emit('initHeader', 2);
                // return this.$router.push({
                //     path: '/task',
                // });
                return this.$bus.emit('initTask', true, {}, 1);
            },

            async getUserCount(){
                let res = await this.$api.getHttp('statistics/overview');
                // console.log('this.getUserCount---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.userCount = {} = res.data.data;
            },

            async __ageCharts(){
                let res = await this.$api.getHttp('statistics/age/distribution');
                // console.log('this.ageCharts---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                let data = res.data.data;

                this.ageCharts = this.$echarts.init(document.getElementById('ageCharts'));

                let option = {
                    title: {
                        text: '年龄统计'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // data: ['所有用户', '脑健康正常', '心理健康正常'],
                        data: ['年龄'],
                        right: '3%',
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: data.name,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '年龄',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            data: data.value,
                            itemStyle: {
                                color: 'rgb(0, 204, 153)'
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {offset: 0, color: 'rgba(0, 204, 153, 1)'}, // 0% 处的颜色
                                        {offset: 1, color: 'rgba(0, 204, 153, 0)'}, // 100% 处的颜色
                                    ],
                                    global: false // 缺省为 false
                                }
                            },
                        },
                        // {
                        //     name: '脑健康正常',
                        //     type: 'line',
                        //     stack: 'Total',
                        //     smooth: true,
                        //     data: [220, 182, 191, 234, 290, 330, 310]
                        // },
                        // {
                        //     name: '心理健康正常',
                        //     type: 'line',
                        //     stack: 'Total',
                        //     smooth: true,
                        //     data: [150, 232, 201, 154, 190, 330, 410]
                        // },
                    ]
                };

                this.ageCharts.setOption(option, true);
                window.addEventListener("resize", () => {
                    this.ageCharts.resize();
                });
            },
            async __useCharts(){
                let res = await this.$api.getHttp('statistics/assess/exercise');
                // console.log('this.useCharts---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                if (!res.data.data) return;
                let data = res.data.data;
                let xAxis = [], tranData = [], examData = [];
                for (let i = 0; i < data.assess.length; i++) {
                    xAxis.push(data.assess[i].dateTime);

                    tranData.push(data.exercise[i].value);
                    examData.push(data.assess[i].value);
                }

                this.useCharts = this.$echarts.init(document.getElementById('useCharts'));

                let option = {
                    title: {
                        text: '测评统计'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // data: ['练习', '测评'],
                        data: ['测评'],
                        right: '3%',
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xAxis
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        // {
                        //     name: '练习',
                        //     type: 'line',
                        //     // stack: 'Total',
                        //     smooth: true,
                        //     data: tranData,
                        //     itemStyle: {
                        //         color: 'rgb(152, 101, 176)'
                        //     },
                        //     areaStyle: {
                        //         color: {
                        //             type: 'linear',
                        //             x: 0,
                        //             y: 0,
                        //             x2: 0,
                        //             y2: 1,
                        //             colorStops: [
                        //                 {offset: 0, color: 'rgba(152, 101, 176, 1)'}, // 0% 处的颜色
                        //                 {offset: 1, color: 'rgba(152, 101, 176, 0)'}, // 100% 处的颜色
                        //             ],
                        //             global: false // 缺省为 false
                        //         }
                        //     },
                        // },
                        {
                            name: '测评',
                            type: 'line',
                            // stack: 'Total',
                            smooth: true,
                            data: examData,
                            itemStyle: {
                                color: 'rgb(248, 132, 94)'
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {offset: 0, color: 'rgba(248, 132, 94, 1)'}, // 0% 处的颜色
                                        {offset: 1, color: 'rgba(248, 132, 94, 0)'}, // 100% 处的颜色
                                    ],
                                    global: false // 缺省为 false
                                }
                            },
                        },
                    ]
                };

                this.useCharts.setOption(option, true);
                window.addEventListener("resize", () => {
                    this.useCharts.resize();
                });
            },

            async getTask(page){
                let res = await this.$api.getHttp('task/list?page=' + page + '&pageSize=' + 5);
                // console.log('this.getTask---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.tableData = [] = res.data.data.rows;
                this.total = res.data.data.total;
            },

            async onChange(data, index, kind){
                // console.log('this.onChange---------->', data, index, kind);
                if (kind === 0){
                    this.$bus.emit('initHeader', 2);
                    localStorage.setItem('task', JSON.stringify(data));
                    return this.$router.push({
                        path: '/task/details',
                        query: {
                            id: data.id,
                        }
                    });
                }
                this.$bus.emit('initTask', true, data, kind);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/index.vue